import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../store';

const mapStateToProps = (state: RootState) => ({
    warehouses: state.stock.warehouses
});

type OwnProps = {
    selectedWarehouse: number | null;
    onSetWarehouse: (value: unknown) => void;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const WarehouseSelector = ({ warehouses, selectedWarehouse, onSetWarehouse }: Props) => {
    const warehousesArr = useMemo(() => Object.values(warehouses), [warehouses]);
    const defaultWarehouse = warehousesArr.find(c => c.isPrimaryWarehouse === true)?.warehouseId;
    const handleSetWarehouse = (event: SelectChangeEvent<number>) => {
        onSetWarehouse(event.target.value);
    };
    return (
        <FormControl
            size="small"
            variant="standard"
            sx={theme => ({ margin: theme.spacing(1), minWidth: 100 })}
        >
            <InputLabel shrink>Warehouse</InputLabel>
            <Select
                value={selectedWarehouse ?? defaultWarehouse ?? ''}
                onChange={event => handleSetWarehouse(event)}
            >
                {warehousesArr.map(w => (
                    <MenuItem key={w.warehouseId} value={w.warehouseId}>
                        {w.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default connect(mapStateToProps)(WarehouseSelector);
